import React, { useState, useRef, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';

import { CALENDARIO_ES_MX, FORMATO_FECHA_CALENDAR, DEFAULT_MASKS } from '../../../servicios/Constantes';
import { locale, addLocale } from 'primereact/api';
import { ServicioObjetos } from '../../../servicios/ServicioObjetos';
import { ServicioFormatos } from '../../../servicios/ServicioFormatos';
import { ServicioHttp } from '../../../servicios/ServicioHttp';
import { ServicioArchivos } from '../../../servicios/ServicioArchivos';


const PAGINACION_INICIAL = {
    registrosPorPagina: 20,
    numeroPagina: 0,
    restriccionesDinamicas: [],
    datos: [],
    join: {}
};

let estados = [1, 2];

export const Cancelacion = () => {

    addLocale('es', CALENDARIO_ES_MX);
    locale('es');

    const dtDialog = useRef(null);
    const [busqueda, setBusqueda] = useState({});
    const [paginacion, setPaginacion] = useState(PAGINACION_INICIAL);
    const [errores, setErrores] = useState({});
    const toast = useRef(null);
    const [rows, setRows] = useState(0);
    const [first, setFirst] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [cfdi, setCfdi] = useState({});
    const [modalCancelacion, setModalCancelacion] = useState(false);
    const [cancelacion, setCancelacion] = useState({});
    const [mostrarModalResultado, setMostrarModalResultado] = useState(false);
    const [listaResultados, setListaResultados] = useState([]);
    const [admin, setAdmin] = useState(false);
    const [entidades, setEntidades] = useState({});

    const motivosCancelacion = [{ value: "01", label: "Comprobante emitido con errores con relación" }, { value: "02", label: "Comprobante emitido con errores sin relación" }, { value: "03", label: "No se llevó a cabo la operación" }, { value: "04", label: "Operación nominativa relacionada en una factura global" }];

    useEffect(() => {
        setRows(paginacion.registrosPorPagina);
        setTotalRecords(paginacion.registrosTotales);
        verificarAdministrador();
    }, [paginacion]);

    const verificarAdministrador = () => {
        ServicioHttp.consumirPostHttp('perfil/validar_usuario.json').then(response => {
            if (response.data.error) {
                consultaEntidades();
                setAdmin(response.data.error);

            }
        }).catch(error => {

        });
    }

    const consultaEntidades = () => {
        let paginacion_entidad = {
            registrosPorPagina: 10000,
            numeroPagina: 0,
            restriccionesDinamicas: [],
            datos: []
        };
        ServicioHttp.consumirPostHttp('entidad/consulta.json', paginacion_entidad).then(response => {
            console.log(response.data.objeto.datos);
            setEntidades(response.data.objeto.datos);
        }).catch(error => {

        });
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setBusqueda(valoresUsuarioPrevios => ({
            ...valoresUsuarioPrevios,
            [name]: value
        }));
    };

    const handleChangeCancelacion = e => {
        const { name, value } = e.target;
        setCancelacion(valoresPrevios => ({
            ...valoresPrevios,
            [name]: value
        }));
    }

    const buscar = () => {
        let erroresFrmBusqueda = validarFrmBusqueda();
        setErrores(erroresFrmBusqueda);
        if (ServicioObjetos.esObjetoVacio(erroresFrmBusqueda)) {
            paginacion.numeroPagina = 0;
            paginar();
        }
    }

    const paginar = () => {
        asignarRestricciones();
        ServicioHttp.consumirPostHttp('consulta/recibos_nomina.json', paginacion).then(response => {
            toast.current.show({ severity: response.data.error === false ?"success" : "error", summary: '', detail: response.data.mensaje, life: 8000 });
            setPaginacion(response.data.objeto);
        }).catch(error => {
            setPaginacion(paginacion);
            toast.current.show({ severity: 'error', summary: '', detail: "Error de conexion al servidor", life: 8000 });
        });
    }

    const onPage = (event) => {
        setFirst(event.first);
        setRows(event.rows);
        setCurrentPage(event.page + 1);
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        funcionPaginacion(paginacion);
    }

    const validarFrmBusqueda = () => {
        let errores = {};
        if (!ServicioObjetos.esObjetoVacio(busqueda.fechaInicial) && ServicioObjetos.esObjetoVacio(busqueda.fechaFinal)) {
            errores.fechaFinal = "La fecha final es requerida cuando la fecha inicial existe";
        }
        if (ServicioObjetos.esObjetoVacio(busqueda.fechaInicial) && !ServicioObjetos.esObjetoVacio(busqueda.fechaFinal)) {
            errores.fechaInicial = "La fecha inicial es requerida cuando la fecha final existe";
        }
        return errores;
    }

    const asignarRestricciones = () => {
        paginacion.restriccionesDinamicas = [];
        if (!ServicioObjetos.esObjetoVacio(busqueda.entidad)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'alias_tcEntidad.id',
                valorPropiedad: busqueda.entidad.id,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }

        if (!ServicioObjetos.esObjetoVacio(busqueda.fechaInicial) && !ServicioObjetos.esObjetoVacio(busqueda.fechaFinal)) {
            let laFechaInicial = ServicioFormatos.formatearFechaString(busqueda.fechaInicial);
            let laFechaFinal = ServicioFormatos.formatearFechaString(busqueda.fechaFinal).replace('00:00:00', '23:59:59');
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'between',
                nombrePropiedad: 'fechaCreacion',
                valorPropiedad: null,
                fechaIncialBetween: laFechaInicial,
                fechaFinalBetween: laFechaFinal
            });
        }
        if (!ServicioObjetos.esObjetoVacio(busqueda.rfcEmisor)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'rfcEmisor',
                valorPropiedad: busqueda.rfcEmisor,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }
        if (!ServicioObjetos.esObjetoVacio(busqueda.rfcReceptor)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'rfcReceptor',
                valorPropiedad: busqueda.rfcReceptor,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }
        if (!ServicioObjetos.esObjetoVacio(busqueda.uuid)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'uuid',
                valorPropiedad: busqueda.uuid,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }
        if (!ServicioObjetos.esObjetoVacio(busqueda.total)) {
            paginacion.restriccionesDinamicas.push({
                tipoRestriccion: 'eq',
                nombrePropiedad: 'total',
                valorPropiedad: busqueda.total,
                fechaIncialBetween: null,
                fechaFinalBetween: null,
                coleccionIn: null
            });
        }

        paginacion.restriccionesDinamicas.push({
            tipoRestriccion: "in",
            nombrePropiedad: "estado",
            coleccionIn: estados
        });

        paginacion.join = { "ttUsuario": "alias_ttUsuario",  "ttLayout": "alias_ttLayout"};

        setPaginacion(paginacion);
    }

    const funcionPaginacion = (laPaginacion) => {
        setPaginacion(laPaginacion);
        paginar();
    }

    const reiniciar = () => {
        setBusqueda({});
        setPaginacion(PAGINACION_INICIAL);
        setErrores({});
    }


    const columnaXmlCancelado = (rowData, column) => {
        return (<div>
            {rowData.estado === 2 ?
                <React.Fragment>
                    <Button icon="pi pi-file" className="p-button-rounded p-button-success p-mr-2" onClick={() => descargarXMl(rowData)} />
                </React.Fragment>
                : ""}
        </div>
        );
    }

    const descargarXMl = (object) => {
        ServicioArchivos.descargaArchivo(`documento/descarga_archivo_cancelado.json`, object);
    }

    const columnaMoneda = (rowData, column) => {
        return ServicioFormatos.formatearModena(rowData.total);
    }

    const columnaFecha = (rowData, column) => {
        return ServicioFormatos.formatearFechaPago(rowData.fechaPago);
    }

    const onIndexTemplate = (rowData, column) => {
        return <div>
            {rowData.estado === 1 ?
                <React.Fragment>
                    <Button icon="pi pi-times-circle" title="Cancelar Recibo de Nómina" className="p-button-rounded p-mr-2" onClick={() => mostrarModalCfdiNomina(rowData)} />
                </React.Fragment>
                : ""}
        </div>
    }

    const columnaEstado = (rowData, column) => {
        return <div>
            {rowData.estado === 1 ?
                <React.Fragment>
                    <Button icon="pi pi-check" title="Activo" className="p-button-rounded p-button-info p-mr-2" />
                </React.Fragment>
                :
                <React.Fragment>
                    <Button icon="pi pi-times" title="Cancelado" className="p-button-rounded p-button-danger p-mr-2" />
                </React.Fragment>
            }
        </div>
    }

    const mostrarModalCfdiNomina = (objeto) => {
        setModalCancelacion(true);
        setCfdi(objeto);

    }

    const cancelarCfdiNomina = () => {
        try {
           
          
            if (ServicioObjetos.esObjetoVacio(cancelacion.motivo))
                throw new Error("Motivo de cancelación requerido.");
            if (cancelacion.motivo === "01" && ServicioObjetos.esObjetoVacio(cancelacion.uuid))
                throw new Error("Folio Sustitución requerido.");
                if (cancelacion.motivo !== "02" ){
        if (ServicioObjetos.esObjetoVacio(cancelacion.uuid))
                throw new Error("Folio fiscal requerido.");
                }

            let listaEnvio = [];
            listaEnvio.push(cfdi);
            ServicioHttp.consumirPostHttp("cancelacion/cancelar_cfdi.json", { cancelacion: cancelacion, listaCFDI: listaEnvio }).then(response => {
                setCancelacion({});
                setModalCancelacion(false);
                setCfdi({});
                setListaResultados(response.data.lista);
                setMostrarModalResultado(true);
                dtDialog.current.exportCSV();
                paginar();
            })

        } catch (error) {
            toast.current.show({ severity: 'error', summary: '', detail: error.message, life: 8000 });
        }

    }

    const cerrarModalCancelacion = () => {
        setModalCancelacion(false);
        setCfdi({});

    }

    const renderFooter = (name) => {
        return (
            <div>
                <Button label="Cerrar" icon="pi pi-times" onClick={cerrarModalCancelacion} className="p-button-text" />
                <Button label="Cancelar" icon="pi pi-check" onClick={cancelarCfdiNomina} autoFocus />
            </div>
        );
    }

    const cerrarModalResultados = () => {
        setMostrarModalResultado(false);
    }

    const piePaginaModalRestultados = () => (
        <div>
            <Button label="Cerrar" icon="pi pi-times" onClick={cerrarModalResultados} />
        </div>
    );



    return (
        <>
            <Toast ref={toast} />

            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h5>Cancelar Cfdi Timbrados</h5>
                        <p>En esta sección usted podrá cancelar todos los Cfdi que ha timbrado en el portal</p>
                    </div>
                    <div className="card">
                        <h5>Para realizar la búsqueda elije uno o varios criterios</h5>
                        <div className="p-fluid formgrid grid">
                            {admin ?
                                <>
                                    <div className="field col-12 md:col-6">
                                        <label htmlFor="uuid">Entidad:</label>
                                        <Dropdown name="entidad" value={busqueda.entidad} options={entidades} optionLabel="descripcion" onChange={handleChange} placeholder="Seleciona Entidad" />
                                    </div>
                                    <div className="field col-12 md:col-6">
                                        <label htmlFor="uuid"></label>
                                        <label htmlFor="uuid"></label>
                                    </div>
                                </> : ""}
                            <div className="field col-12 md:col-6">
                                <label htmlFor="uuid">Folio Fiscal:</label>
                                <InputText id="uuid" type="text" name="uuid"
                                    value={busqueda.uuid || ""} onChange={handleChange} />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="rfcEmisor">Rfc Emisor:</label>
                                <InputText id="rfcEmisor" type="text" name="rfcEmisor"
                                    value={busqueda.rfcEmisor || ""} onChange={handleChange} />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="rfcReceptor">Rfc Receptor:</label>
                                <InputText id="rfcReceptor" type="text" name="rfcReceptor"
                                    value={busqueda.rfcReceptor || ""} onChange={handleChange} />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="total">Total:</label>
                                <InputText id="total" type="text" name="total"
                                    value={busqueda.total || ""} onChange={handleChange}
                                    keyfilter={DEFAULT_MASKS.money} />
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="fechaInicial">Fecha Emisión Inicial:</label>
                                <Calendar dateFormat={FORMATO_FECHA_CALENDAR} appendTo={document.body}
                                    id="fechaInicial" showIcon name="fechaInicial"
                                    value={busqueda.fechaInicial || ""} onChange={handleChange} className={errores.fechaInicial ? "p-invalid" : ""} />
                                {errores.fechaInicial ? <div><Message severity="error" text={errores.fechaInicial} /></div> : null}
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="zip">Fecha Emisión Final:</label>
                                <Calendar dateFormat={FORMATO_FECHA_CALENDAR} appendTo={document.body}
                                    id="fechaFinal" showIcon name="fechaFinal"
                                    value={busqueda.fechaFinal || ""} onChange={handleChange} className={errores.fechaFinal ? "p-invalid" : ""} />
                                {errores.fechaFinal ? <div><Message severity="error" text={errores.fechaFinal} /></div> : null}
                            </div>
                            <div className="col-12 md:col-3 md:col-offset-6">
                                <Button label="Reiniciar" icon="pi pi-refresh" onClick={reiniciar} className="p-button-warning" />
                            </div>
                            <div className="col-12 md:col-3">
                                <Button label="Buscar" icon="pi pi-search" onClick={buscar} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid table-demo">
                {!ServicioObjetos.esObjetoVacio(paginacion.datos) ? <div className="col-12">
                    <div className="card">

                        <h5>Mis Cfdi</h5>
                        <DataTable value={paginacion.datos} className="p-datatable-gridlines" showGridlines
                            paginator lazy responsiveLayout="scroll"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            currentPageReportTemplate="Mostrando {first} al {last} de {totalRecords} registros"
                            rows={rows} first={first} totalRecords={totalRecords}
                            rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} onPage={onPage}>
                            <Column header="Cancelar Recibo" body={onIndexTemplate} style={{ width: '40px' }} />
                            <Column field="nombreReceptor" header="Nombre Receptor" />
                            <Column field="rfcReceptor" header="Rfc Receptor" />
                            <Column field="folioFiscal" header="Folio Fiscal UUID" />
                            
                            <Column body={columnaFecha} header="Fecha de Pago" />
                            <Column body={columnaEstado} header="Estado" />
                            <Column body={columnaMoneda} header="Total" />
                            <Column body={columnaXmlCancelado} header="Acuse" />

                        </DataTable>
                    </div>
                </div> : ""}

                <Dialog header="Confirmación para cancelar" visible={modalCancelacion} footer={renderFooter} onHide={cerrarModalCancelacion}>
                    <div className="card p-fluid">
                        <h5></h5>
                        <div className="field">
                            <label htmlFor="name1">Motivo de cancelación:</label>
                            <Dropdown name="motivo" value={cancelacion.motivo || ''} options={motivosCancelacion} onChange={handleChangeCancelacion} placeholder="Selecciona motivo" autoWidth={false} />
                        </div>
                        {cancelacion.motivo === "01" ?
                            <div className="field">
                                <label htmlFor="email1">Folio fiscal que lo sustituira</label>
                                <InputText id="sustitucion" type="text" name="uuid" value={cancelacion.uuid || ''} onChange={handleChangeCancelacion} />
                            </div>
                            :
                            ""}
                    </div>
                </Dialog>

                <Dialog header="Resultado de la cancelación" visible={mostrarModalResultado} closeOnEscape={false} closable={false} footer={piePaginaModalRestultados} onHide={cerrarModalResultados}>
                    {listaResultados.length > 0 ?
                        <DataTable ref={dtDialog} value={listaResultados}>
                            <Column field="nombreReceptor" header="Nombre Receptor" />
                            <Column field="rfcReceptor" header="R.F.C Receptor" />
                            <Column field="folioFiscal" header="Folio Fiscal" />
                            <Column body={(e) => ServicioFormatos.formatearFechaString(e.fechaCancelacion)} header="Fecha Cancelación" />
                            <Column body={(e) => (e.estadoCancelacion === "201" || e.estadoCancelacion === "202") ? <p style={{ backgroundColor: '#339900', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Cancelado</p> : <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>No Cancelado</p>} header="Estado SAT" />
                            <Column field="estadoCancelacion" header="Código SAT" />
                        </DataTable>
                        : null}
                </Dialog>
            </div>
        </>)
}